import { t } from "i18next";

import React from "react";

export const ValidateStep = (props: any): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 224 65"
        >
            <g
                id="Groupe_28"
                data-name="Groupe 28"
                transform="translate(-6706 4106)"
            >
                <g
                    id="Rectangle_22"
                    data-name="Rectangle 22"
                    transform="translate(6706 -4106)"
                    fill="#323333"
                    stroke="#000"
                    stroke-width="2"
                >
                    <rect width="224" height="65" rx="9" stroke="none" />
                    <rect
                        x="1"
                        y="1"
                        width="222"
                        height="63"
                        rx="8"
                        fill="none"
                    />
                </g>
                <text
                    id="Validate"
                    transform="translate(6818 -4062)"
                    fill="#fff"
                    font-size="30"
                    font-family="HelveticaNeue-Medium, Helvetica Neue"
                    font-weight="500"
                >
                    <tspan x="-46.695" y="0">
                        {t("Validate", {
                            lng: props.selectedLanguage,
                        })}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};
